import { render } from "./aiServices.vue?vue&type=template&id=17347771&scoped=true"
import script from "./aiServices.vue?vue&type=script&lang=js"
export * from "./aiServices.vue?vue&type=script&lang=js"

import "./aiServices.vue?vue&type=style&index=0&id=17347771&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17347771"]])

export default __exports__